
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { FileText, Filter } from "lucide-react";

interface CustomerActionsProps {
  onFilterClick: () => void;
  onExport: (format: 'txt' | 'csv' | 'xlsx') => void;
}

export function CustomerActions({ onFilterClick, onExport }: CustomerActionsProps) {
  return (
    <div className="flex gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="w-full md:w-auto">
            Exportar
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => onExport('txt')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Texto (.txt)</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onExport('csv')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>CSV (.csv)</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onExport('xlsx')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Excel (.xlsx)</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      
      <Button variant="outline" className="w-full md:w-auto" onClick={onFilterClick}>
        <Filter className="mr-2 h-4 w-4" />
        Filtrar
      </Button>
      
      <Button className="bg-brand-blue hover:bg-brand-blue/90 w-full md:w-auto">
        Importar Clientes
      </Button>
    </div>
  );
}
